import { brands as staticBrands, type BrandData } from '../data/products';

const WP_API = import.meta.env.VITE_WP_API_URL as string | undefined;

// Module-level cache — survives across component mounts/unmounts
let cache: BrandData[] | null = null;
let pending: Promise<BrandData[]> | null = null;

export async function fetchBrands(): Promise<BrandData[]> {
  // 1. Already cached
  if (cache) return cache;

  // 2. No WP URL configured — use static data immediately
  if (!WP_API) {
    cache = staticBrands;
    return staticBrands;
  }

  // 3. De-duplicate concurrent calls
  if (pending) return pending;

  pending = (async () => {
    try {
      const res = await fetch(`${WP_API}/wp-json/bc/v1/brands`, {
        headers: { Accept: 'application/json' },
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data: BrandData[] = await res.json();

      if (!Array.isArray(data) || data.length === 0) throw new Error('Empty response');

      cache = data;
      return data;
    } catch (err) {
      console.warn('[BudzevinaCarbon] WP API unavailable, falling back to static data.', err);
      cache = staticBrands;
      return staticBrands;
    } finally {
      pending = null;
    }
  })();

  return pending;
}

/** Invalidate the cache (useful for admin/dev — call and then fetchBrands() again) */
export function invalidateBrandsCache() {
  cache = null;
  pending = null;
}
